import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-supply-chain-days-inventory-calculator',
  templateUrl: './supply-chain-days-inventory-calculator.component.html',
  styleUrls: ['./supply-chain-days-inventory-calculator.component.css']
})
export class SupplyChainDaysInventoryCalculatorComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    } )

  } 
  daysIn(n1,n2){
    var daysInv=(n1/n2)*365;
    var daysInvsimple= daysInv.toFixed(2);
    return daysInvsimple ;
    }

}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/supply-chain-days-inventory-calculator/supply-chain-days-inventory-calculator.component.ts